// extracted by mini-css-extract-plugin
export default {"wrapper":"U9CTItg6GREz7y7_4rAD","collapse":"kEp6qXuubNKW3VHgQTUT","content":"pc2ZsiqWVar3cudyTg2E"};